import { assertNeverFrequency } from "../types/schedule";
export function frequencyToTier(frequency) {
    if (!frequency)
        return 1;
    var key = frequency;
    switch (key) {
        case "DAILY":
        case "FOUR_WEEKLY":
        case "THREE_WEEKLY":
        case "SEMIWEEKLY":
            return 3;
        case "WEEKLY":
        case "BIWEEKLY":
        case "SEMIMONTHLY":
        case "THREE_MONTHLY":
            return 2;
        case "MONTHLY":
        case "ELEVEN_YEARLY":
        case "TEN_YEARLY":
        case "NINE_YEARLY":
        case "EIGHT_YEARLY":
        case "SEVEN_YEARLY":
        case "BIMONTHLY":
        case "FIVE_YEARLY":
        case "QUARTERLY":
        case "THREE_YEARLY":
        case "SEMIANNUAL":
        case "ANNUAL":
        case "BIENNIAL":
        case "TRIENNIAL":
        case "IRREGULAR":
        case "UNKNOWN":
            return 1;
        default:
            return assertNeverFrequency(key);
    }
}
